import Triggerable from "metabase/components/Triggerable";
import Modal from "metabase/components/Modal";

/**
 * @deprecated use Modal + useState
 */
export default Triggerable(Modal);
